import Market from '@root/core/src/models/market';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import Responsive from '@root/core/src/utils/responsive';
import { Colors, StyleSheet } from '@root/core/src/utils/styles';
import { H4 } from '@root/joinroot.com/src/components/text';

export default function ChartLegend({
  lineChartData,
  yAxisLegend,
  stayHomeLabel,
}) {
  return (
    <div css={styles.legendContainer}>
      <H4 css={styles.metricLegend}>{yAxisLegend}</H4>
      <ul css={styles.dataPointLegend}>
        {lineChartData.map(({ id, color }, i) => (
          <li
            css={styles.dataPoint}
            key={i}
          >
            <div
              css={[
                styles.dataPointColor,
                id === stayHomeLabel && styles.isStayHome,
                {
                  backgroundColor: color,
                },
              ]}
            />
            {id.length === 2 ? Market.MAPPING[id] : id}
          </li>
        ))}
      </ul>
    </div>
  );
}

ChartLegend.propTypes = {
  lineChartData: PropTypes.array,
  stayHomeLabel: PropTypes.string,
  yAxisLegend: PropTypes.string,
};

const styles = StyleSheet.create({
  legendContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: 1200,
    padding: '30px 20px 10px 10px',
    ...Responsive.md({
      flexDirection: 'row',
      alignItems: 'center',
    }),
  },
  metricLegend: {
    margin: '8px 20px 8px 0',
  },
  dataPointLegend: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    margin: '0 -10px',
    ...Responsive.md({
      justifyContent: 'flex-end',
    }),
  },
  dataPoint: {
    display: 'flex',
    alignItems: 'center',
    margin: '2px 10px',
    color: Colors.gray50(),
    fontSize: 16,
  },
  dataPointColor: {
    width: 14,
    height: 14,
    marginRight: 6,
    borderRadius: 50,
  },
  isStayHome: {
    borderRadius: 1,
  },
});

